import React from 'react';
import SignInForm from "./SignInForm";
import withSignOut from "../../WithSignOut";

/**
 * Sign in page wrapper
 */
const SignInPage = (props, {history}) => {
    return (
        <div className="container">
            <SignInForm history={history}/>
        </div>
    );
};

export default withSignOut(SignInPage);


// WEBPACK FOOTER //
// ./src/components/auth/signin/SignInPage.jsx